import { useEffect, useState } from "react";
import "./UnmatchedSkills.scss";
import { getUnmatchedSkills } from "../../service/Company/company";
import useDebounce from "../../utils/Hooks/useDebounce";
import Loader from "../../components/Loader/Loader";
import { Pagination, TemplateSearch } from "ui-components";
import { useTranslation } from "react-i18next";
import DataNotAvailable from "../../utils/DataNotFound/DataNotAvailable";
import { capitalizeFirstLetter } from "../../utils/Common/Constant";
const UnmatchedSkills = () => {
  const [unmatchedSkills, setUnmatchedSkills] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(12);
  const [search, setSearch] = useState<string>("");
  const searchDebounce = useDebounce(search, 500);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [managePaginationRef, setManagePaginationRef] = useState<any>(0);
  const { t } = useTranslation();
  const getUnmatchedSkillsApi = async () => {
    setLoading(true);
    const res = await getUnmatchedSkills(currentPage, pageSize, search);
    if (res) {
      setUnmatchedSkills(res?.data?.data);
      setTotalCount(res?.data?.totalCount);
    }
    setLoading(false);
  };
  useEffect(() => {
    scrollTo(0, 0);
  }, [managePaginationRef]);
  useEffect(() => {
    getUnmatchedSkillsApi();
  }, [currentPage, pageSize, searchDebounce]);
  return (
    <div className="minHeight container-fluid">
      <div className="unmatchedListSection ">
        <div className="unmatchedListHeader">
          <div className="unmatchedListTitleDiv">
            <div className="unmatchedListTitle">{t("GENERAL.NEW_SKILLS")}</div>
            <div className="unmatchedMessage">
              {t("GENERAL.UNMATCHED_SKILLS_MESSAGE")}
            </div>
          </div>
          <TemplateSearch
            onChange={(e) => {
              setCurrentPage(1);
              setSearch(e);
            }}
            iconName="searchList"
          />
        </div>
        <div className="totalCountDiv">
          <p className="totalContent">
            {t("GENERAL.TOTAL_SKILLS")} : {totalCount || 0}
          </p>
        </div>
        {loading ? (
          <div className="unmatchedSkillsLoader">
            <Loader />
          </div>
        ) : (
          <div>
            <div className="unmatchedSkillsCards">
              {unmatchedSkills?.length > 0 ? (
                <div className="row mb-4 ">
                  {unmatchedSkills?.map((item: any) => (
                    <div className="col-lg-3 mt-3" key={item?.unmatchedSkillId}>
                      <div className="skillCard">
                        <div className="skillDetails">
                          <h5 className="skillName">
                            {capitalizeFirstLetter(item?.skillName)}
                          </h5>
                          <p className="skillCount">
                            {t("GENERAL.OCCURRENCES")} :{" "}
                            <b>{item?.count}</b>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <DataNotAvailable />
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-12">
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage ?? 1}
                  totalCount={totalCount || 0}
                  pageSize={pageSize}
                  onPageChange={(page: any) => {
                    setCurrentPage(page);
                    setManagePaginationRef(Math.random());
                  }}
                  ofLabel={t("GENERAL.OF")}
                  resultLabel={t("GENERAL.RESULTS")}
                  setPageSize={setPageSize}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnmatchedSkills;
